var scope_0 = require('/home/node/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3768f330a957deb6fb79969b32957df2.js').default;
var scope_1 = require('/home/node/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/75a8a4f73071d365bc289675623764b0.js').default;
var scope_2 = require('/home/node/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ae751725cbb5b77ab38d97be9e924ff3.js').default;
var scope_3 = require('/home/node/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b3d907b8d73c6f3988d25823ed07c111.js').default;
var scope_4 = require('/home/node/app/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    